const initial = {
  open: false,
  message: "",
  type: "",
  duration: ""
};

export default (state = initial, event) => {
  switch (event.type) {
    case "SHOW_NOTIFICATION":
      return {
        ...state,
        open:event.data.open,
        type: event.data.type,
        message: event.data.message,
      };
    default:
      return state;
  }
};